'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefix = undefined;
var _isDate2 = require('lodash/isDate');
var _isDate3 = _interopRequireDefault(_isDate2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _isFunction2 = require('lodash/isFunction');
var _isFunction3 = _interopRequireDefault(_isFunction2);
var _isUndefined2 = require('lodash/isUndefined');
var _isUndefined3 = _interopRequireDefault(_isUndefined2);
var _last2 = require('lodash/last');
var _last3 = _interopRequireDefault(_last2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _sumBy2 = require('lodash/sumBy');
var _sumBy3 = _interopRequireDefault(_sumBy2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
exports.noElError = noElError;
exports.noDataError = noDataError;
exports.setupElement = setupElement;
exports.selector = selector;
exports.getElementDimensions = getElementDimensions;
exports.getExtentDelta = getExtentDelta;
exports.getRangeDelta = getRangeDelta;
exports.getDomainDelta = getDomainDelta;
exports.getScaleExtent = getScaleExtent;
exports.lineStyle = lineStyle;
exports.fontStyle = fontStyle;
exports.fontBaselineOffset = fontBaselineOffset;
exports.getFormat = getFormat;
exports.getColor = getColor;
exports.getOverColor = getOverColor;
exports.getColorShade = getColorShade;
exports.isScaleLinear = isScaleLinear;
exports.getScaleType = getScaleType;
exports.getTextDimensions = getTextDimensions;
exports.ordinalLabelsOverlap = ordinalLabelsOverlap;
var _lodash = require('lodash.compose');
var _lodash2 = _interopRequireDefault(_lodash);
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _package = require('../../package.json');
var _package2 = _interopRequireDefault(_package);
var _constants = require('../utils/constants');
var C = _interopRequireWildcard(_constants);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var prefix = exports.prefix = '[' + _package2.default.name + '@' + _package2.default.version + ']';
function noElError(el) {
  if (!el) throw new Error('[rcw] no el');
}
function noDataError(data) {
  var _console;
  var noData = (0, _isEmpty3.default)(data);
  for (var _len = arguments.length, msg = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    msg[_key - 1] = arguments[_key];
  }
  if (noData) (_console = console).warn.apply(_console, [prefix].concat(msg, ['no data']));
  return noData;
}
function setupElement(selection, tag, cls) {
  return selection.append(tag).classed(cls, true);
}
function selector(_selector) {
  return '.' + _selector;
}
function getElementDimensions(element) {
  var box = element.node().getBBox();
  return {
    width: box.width,
    height: box.height,
    x: box.x,
    y: box.y
  };
}
function getExtentDelta(extent) {
  return (0, _sumBy3.default)(extent, Math.abs);
}
function getRangeDelta(range) {
  return getExtentDelta([(0, _head3.default)(range) - (0, _last3.default)(range)]);
}
function getDomainDelta(domain) {
  return getExtentDelta([(0, _head3.default)(domain) - (0, _last3.default)(domain)]);
}
function getScaleExtent(scale) {
  return (0, _isUndefined3.default)(scale.rangeExtent) ? scale.range() : scale.rangeExtent();
}
function lineStyle(_ref) {
  var color = _ref.color,
    thickness = _ref.thickness;
  return {
    fill: 'none',
    'shape-rendering': 'crispEdges',
    stroke: color,
    'stroke-width': thickness
  };
}
function fontStyle(_ref2) {
  var family = _ref2.family,
    size = _ref2.size,
    color = _ref2.color,
    weight = _ref2.weight;
  return {
    'font-family': family,
    'font-size': size + 'px',
    fill: color,
    'font-weight': weight,
    'user-select': 'none',
    cursor: 'default'
  };
}
function fontBaselineOffset(textElement, baseline) {
  // IE does not support dominant-baseline style, need to position text manually
  var textHeight = getElementDimensions(textElement).height;
  var offset = 0;
  switch (baseline) {
    case C.TEXT_ABOVE:
      offset = textHeight / 2 * -1;
      break;
    case C.TEXT_MIDDLE:
      offset = 0;
      break;
    case C.TEXT_BELOW:
      offset = textHeight / 2;
      break;
  }
  return offset;
}
function getFormat(_ref3) {
  var proc = _ref3.proc,
    pattern = _ref3.pattern,
    isTime = _ref3.isTime;
  if ((0, _isFunction3.default)(proc)) return proc;
  return isTime ? _d2.default.time.format(pattern) : (0, _lodash2.default)(parseFloat, _d2.default.format(pattern));
}
function getColor(options, _ref4) {
  var index = _ref4.index,
    type = _ref4.type;
  var defaultKeyColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'colors';
  var colors = (0, _get3.default)(options, type ? type + 'Colors' : defaultKeyColor, []);
  return colors[index % colors.length];
}
function getOverColor(options, _ref5) {
  var index = _ref5.index,
    type = _ref5.type;
  return getColor(options, {
    index: index,
    type: type
  }, 'overColors');
}
function getColorShade(color, colorCoeff) {
  return _d2.default.rgb(color).brighter(colorCoeff).toString();
}
function isScaleLinear(scale) {
  return (0, _isUndefined3.default)(scale.rangeBand);
}
function getScaleType(scale) {
  if (!(0, _isUndefined3.default)(scale.rangeBand)) {
    return C.ORDINAL;
  }
  if ((0, _isDate3.default)((0, _head3.default)(scale.domain()))) {
    return C.TIME;
  }
  return C.LINEAR;
}
function getTextDimensions(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rotation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var sandBox = element.append('svg:svg');
  var _getElementDimensions = getElementDimensions(element),
    x = _getElementDimensions.width,
    y = _getElementDimensions.height;
  sandBox.append('text').attr({
    x: x,
    y: y
  }).attr('transform', 'rotate(' + rotation + ')').style(fontStyle(options)).text(text);
  var _getElementDimensions2 = getElementDimensions(sandBox),
    width = _getElementDimensions2.width,
    height = _getElementDimensions2.height;
  sandBox.remove();
  return {
    width: width,
    height: height
  };
}
function getTickTextSize(element, rotated, axisKey, options) {
  switch (axisKey) {
    case 'y':
      return options.font.size;
    case 'x':
      if (rotated === C.UNROTATED) return getElementDimensions(element).width;
      var height = options.font.size;
      return Math.abs(height / Math.sin(options.font.rotation * Math.PI / 180));
  }
}
function ordinalLabelsOverlap(selection, axis, axisKey, options, rotated) {
  var scale = axis.scale();
  var maxTicksOffset = 0;
  selection.selectAll('text').each(function (d) {
    var size = getTickTextSize(_d2.default.select(this), rotated, axisKey, options);
    if (size > maxTicksOffset) maxTicksOffset = size;
  });
  var band = scale.rangeBand();
  if (maxTicksOffset >= band) {
    return true;
  }
  return false;
}